// Copyright 2023 LiveKit, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file livekit_models.proto (package livekit, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { MetricsBatch } from "./livekit_metrics_pb";
import { file_livekit_metrics } from "./livekit_metrics_pb";
import { file_logger_options } from "./logger/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file livekit_models.proto.
 */
export const file_livekit_models: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_livekit_metrics, file_logger_options]);

/**
 * @generated from message livekit.Pagination
 */
export type Pagination = Message<"livekit.Pagination"> & {
  /**
   * list entities which IDs are greater
   *
   * @generated from field: string after_id = 1;
   */
  afterId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message livekit.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_livekit_models, 0);

/**
 * @generated from message livekit.TokenPagination
 */
export type TokenPagination = Message<"livekit.TokenPagination"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message livekit.TokenPagination.
 * Use `create(TokenPaginationSchema)` to create a new message.
 */
export const TokenPaginationSchema: GenMessage<TokenPagination> = /*@__PURE__*/
  messageDesc(file_livekit_models, 1);

/**
 * ListUpdate is used for updated APIs where 'repeated string' field is modified.
 *
 * @generated from message livekit.ListUpdate
 */
export type ListUpdate = Message<"livekit.ListUpdate"> & {
  /**
   * set the field to a new list
   *
   * @generated from field: repeated string set = 1;
   */
  set: string[];

  /**
   * append items to a list, avoiding duplicates
   *
   * @generated from field: repeated string add = 2;
   */
  add: string[];

  /**
   * delete items from a list
   *
   * @generated from field: repeated string remove = 3;
   */
  remove: string[];

  /**
   * sets the list to an empty list
   *
   * @generated from field: bool clear = 4;
   */
  clear: boolean;
};

/**
 * Describes the message livekit.ListUpdate.
 * Use `create(ListUpdateSchema)` to create a new message.
 */
export const ListUpdateSchema: GenMessage<ListUpdate> = /*@__PURE__*/
  messageDesc(file_livekit_models, 2);

/**
 * @generated from message livekit.Room
 */
export type Room = Message<"livekit.Room"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint32 empty_timeout = 3;
   */
  emptyTimeout: number;

  /**
   * @generated from field: uint32 departure_timeout = 14;
   */
  departureTimeout: number;

  /**
   * @generated from field: uint32 max_participants = 4;
   */
  maxParticipants: number;

  /**
   * @generated from field: int64 creation_time = 5 [jstype = JS_STRING];
   */
  creationTime: string;

  /**
   * @generated from field: int64 creation_time_ms = 15 [jstype = JS_STRING];
   */
  creationTimeMs: string;

  /**
   * @generated from field: string turn_password = 6;
   */
  turnPassword: string;

  /**
   * @generated from field: repeated livekit.Codec enabled_codecs = 7;
   */
  enabledCodecs: Codec[];

  /**
   * @generated from field: string metadata = 8;
   */
  metadata: string;

  /**
   * @generated from field: uint32 num_participants = 9;
   */
  numParticipants: number;

  /**
   * @generated from field: uint32 num_publishers = 11;
   */
  numPublishers: number;

  /**
   * @generated from field: bool active_recording = 10;
   */
  activeRecording: boolean;

  /**
   * @generated from field: livekit.TimedVersion version = 13;
   */
  version?: TimedVersion | undefined;
};

/**
 * Describes the message livekit.Room.
 * Use `create(RoomSchema)` to create a new message.
 */
export const RoomSchema: GenMessage<Room> = /*@__PURE__*/
  messageDesc(file_livekit_models, 3);

/**
 * @generated from message livekit.Codec
 */
export type Codec = Message<"livekit.Codec"> & {
  /**
   * @generated from field: string mime = 1;
   */
  mime: string;

  /**
   * @generated from field: string fmtp_line = 2;
   */
  fmtpLine: string;
};

/**
 * Describes the message livekit.Codec.
 * Use `create(CodecSchema)` to create a new message.
 */
export const CodecSchema: GenMessage<Codec> = /*@__PURE__*/
  messageDesc(file_livekit_models, 4);

/**
 * @generated from message livekit.PlayoutDelay
 */
export type PlayoutDelay = Message<"livekit.PlayoutDelay"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: uint32 min = 2;
   */
  min: number;

  /**
   * @generated from field: uint32 max = 3;
   */
  max: number;
};

/**
 * Describes the message livekit.PlayoutDelay.
 * Use `create(PlayoutDelaySchema)` to create a new message.
 */
export const PlayoutDelaySchema: GenMessage<PlayoutDelay> = /*@__PURE__*/
  messageDesc(file_livekit_models, 5);

/**
 * @generated from message livekit.ParticipantPermission
 */
export type ParticipantPermission = Message<"livekit.ParticipantPermission"> & {
  /**
   * allow participant to subscribe to other tracks in the room
   *
   * @generated from field: bool can_subscribe = 1;
   */
  canSubscribe: boolean;

  /**
   * allow participant to publish new tracks to room
   *
   * @generated from field: bool can_publish = 2;
   */
  canPublish: boolean;

  /**
   * allow participant to publish data
   *
   * @generated from field: bool can_publish_data = 3;
   */
  canPublishData: boolean;

  /**
   * sources that are allowed to be published
   *
   * @generated from field: repeated livekit.TrackSource can_publish_sources = 9;
   */
  canPublishSources: TrackSource[];

  /**
   * indicates that it's hidden to others
   *
   * @generated from field: bool hidden = 7;
   */
  hidden: boolean;

  /**
   * indicates it's a recorder instance
   * deprecated: use ParticipantInfo.kind instead
   *
   * @generated from field: bool recorder = 8 [deprecated = true];
   * @deprecated
   */
  recorder: boolean;

  /**
   * indicates that participant can update own metadata and attributes
   *
   * @generated from field: bool can_update_metadata = 10;
   */
  canUpdateMetadata: boolean;

  /**
   * indicates that participant is an agent
   * deprecated: use ParticipantInfo.kind instead
   *
   * @generated from field: bool agent = 11 [deprecated = true];
   * @deprecated
   */
  agent: boolean;

  /**
   * if a participant can subscribe to metrics
   *
   * @generated from field: bool can_subscribe_metrics = 12;
   */
  canSubscribeMetrics: boolean;

  /**
   * if a participant can manage an agent session via RemoteSession (control and access state)
   *
   * @generated from field: bool can_manage_agent_session = 13;
   */
  canManageAgentSession: boolean;
};

/**
 * Describes the message livekit.ParticipantPermission.
 * Use `create(ParticipantPermissionSchema)` to create a new message.
 */
export const ParticipantPermissionSchema: GenMessage<ParticipantPermission> = /*@__PURE__*/
  messageDesc(file_livekit_models, 6);

/**
 * @generated from message livekit.ParticipantInfo
 */
export type ParticipantInfo = Message<"livekit.ParticipantInfo"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * @generated from field: string identity = 2;
   */
  identity: string;

  /**
   * @generated from field: livekit.ParticipantInfo.State state = 3;
   */
  state: ParticipantInfo_State;

  /**
   * @generated from field: repeated livekit.TrackInfo tracks = 4;
   */
  tracks: TrackInfo[];

  /**
   * @generated from field: string metadata = 5;
   */
  metadata: string;

  /**
   * timestamp when participant joined room, in seconds
   *
   * @generated from field: int64 joined_at = 6 [jstype = JS_STRING];
   */
  joinedAt: string;

  /**
   * timestamp when participant joined room, in milliseconds
   *
   * @generated from field: int64 joined_at_ms = 17 [jstype = JS_STRING];
   */
  joinedAtMs: string;

  /**
   * @generated from field: string name = 9;
   */
  name: string;

  /**
   * @generated from field: uint32 version = 10;
   */
  version: number;

  /**
   * @generated from field: livekit.ParticipantPermission permission = 11;
   */
  permission?: ParticipantPermission | undefined;

  /**
   * @generated from field: string region = 12;
   */
  region: string;

  /**
   * indicates the participant has an active publisher connection
   * and can publish to the server
   *
   * @generated from field: bool is_publisher = 13;
   */
  isPublisher: boolean;

  /**
   * @generated from field: livekit.ParticipantInfo.Kind kind = 14;
   */
  kind: ParticipantInfo_Kind;

  /**
   * @generated from field: map<string, string> attributes = 15;
   */
  attributes: { [key: string]: string };

  /**
   * @generated from field: livekit.DisconnectReason disconnect_reason = 16;
   */
  disconnectReason: DisconnectReason;

  /**
   * @generated from field: repeated livekit.ParticipantInfo.KindDetail kind_details = 18;
   */
  kindDetails: ParticipantInfo_KindDetail[];

  /**
   * @generated from field: repeated livekit.DataTrackInfo data_tracks = 19;
   */
  dataTracks: DataTrackInfo[];

  /**
   * protocol version used for client feature compatibility
   *
   * @generated from field: int32 client_protocol = 20;
   */
  clientProtocol: number;

  /**
   * capabilities the participant's client advertises, mirrored from ClientInfo.
   * Lets other participants perform client-side feature detection.
   *
   * @generated from field: repeated livekit.ClientInfo.Capability capabilities = 21;
   */
  capabilities: ClientInfo_Capability[];
};

/**
 * Describes the message livekit.ParticipantInfo.
 * Use `create(ParticipantInfoSchema)` to create a new message.
 */
export const ParticipantInfoSchema: GenMessage<ParticipantInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 7);

/**
 * @generated from enum livekit.ParticipantInfo.State
 */
export enum ParticipantInfo_State {
  /**
   * websocket' connected, but not offered yet
   *
   * @generated from enum value: JOINING = 0;
   */
  JOINING = 0,

  /**
   * server received client offer
   *
   * @generated from enum value: JOINED = 1;
   */
  JOINED = 1,

  /**
   * ICE connectivity established
   *
   * @generated from enum value: ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * WS disconnected
   *
   * @generated from enum value: DISCONNECTED = 3;
   */
  DISCONNECTED = 3,
}

/**
 * Describes the enum livekit.ParticipantInfo.State.
 */
export const ParticipantInfo_StateSchema: GenEnum<ParticipantInfo_State> = /*@__PURE__*/
  enumDesc(file_livekit_models, 7, 0);

/**
 * @generated from enum livekit.ParticipantInfo.Kind
 */
export enum ParticipantInfo_Kind {
  /**
   * standard participants, e.g. web clients
   *
   * @generated from enum value: STANDARD = 0;
   */
  STANDARD = 0,

  /**
   * only ingests streams
   *
   * @generated from enum value: INGRESS = 1;
   */
  INGRESS = 1,

  /**
   * only consumes streams
   *
   * @generated from enum value: EGRESS = 2;
   */
  EGRESS = 2,

  /**
   * SIP participants
   *
   * @generated from enum value: SIP = 3;
   */
  SIP = 3,

  /**
   * LiveKit agents
   *
   * @generated from enum value: AGENT = 4;
   */
  AGENT = 4,

  /**
   * Connectors participants
   *
   * @generated from enum value: CONNECTOR = 7;
   */
  CONNECTOR = 7,

  /**
   * Bridge participants
   *
   * NEXT_ID: 9
   *
   * @generated from enum value: BRIDGE = 8;
   */
  BRIDGE = 8,
}

/**
 * Describes the enum livekit.ParticipantInfo.Kind.
 */
export const ParticipantInfo_KindSchema: GenEnum<ParticipantInfo_Kind> = /*@__PURE__*/
  enumDesc(file_livekit_models, 7, 1);

/**
 * @generated from enum livekit.ParticipantInfo.KindDetail
 */
export enum ParticipantInfo_KindDetail {
  /**
   * @generated from enum value: CLOUD_AGENT = 0;
   */
  CLOUD_AGENT = 0,

  /**
   * @generated from enum value: FORWARDED = 1;
   */
  FORWARDED = 1,

  /**
   * @generated from enum value: CONNECTOR_WHATSAPP = 2;
   */
  CONNECTOR_WHATSAPP = 2,

  /**
   * @generated from enum value: CONNECTOR_TWILIO = 3;
   */
  CONNECTOR_TWILIO = 3,

  /**
   * NEXT_ID: 5
   *
   * @generated from enum value: BRIDGE_RTSP = 4;
   */
  BRIDGE_RTSP = 4,
}

/**
 * Describes the enum livekit.ParticipantInfo.KindDetail.
 */
export const ParticipantInfo_KindDetailSchema: GenEnum<ParticipantInfo_KindDetail> = /*@__PURE__*/
  enumDesc(file_livekit_models, 7, 2);

/**
 * @generated from message livekit.Encryption
 */
export type Encryption = Message<"livekit.Encryption"> & {
};

/**
 * Describes the message livekit.Encryption.
 * Use `create(EncryptionSchema)` to create a new message.
 */
export const EncryptionSchema: GenMessage<Encryption> = /*@__PURE__*/
  messageDesc(file_livekit_models, 8);

/**
 * @generated from enum livekit.Encryption.Type
 */
export enum Encryption_Type {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: GCM = 1;
   */
  GCM = 1,

  /**
   * @generated from enum value: CUSTOM = 2;
   */
  CUSTOM = 2,
}

/**
 * Describes the enum livekit.Encryption.Type.
 */
export const Encryption_TypeSchema: GenEnum<Encryption_Type> = /*@__PURE__*/
  enumDesc(file_livekit_models, 8, 0);

/**
 * @generated from message livekit.SimulcastCodecInfo
 */
export type SimulcastCodecInfo = Message<"livekit.SimulcastCodecInfo"> & {
  /**
   * @generated from field: string mime_type = 1;
   */
  mimeType: string;

  /**
   * @generated from field: string mid = 2;
   */
  mid: string;

  /**
   * @generated from field: string cid = 3;
   */
  cid: string;

  /**
   * @generated from field: repeated livekit.VideoLayer layers = 4;
   */
  layers: VideoLayer[];

  /**
   * @generated from field: livekit.VideoLayer.Mode video_layer_mode = 5;
   */
  videoLayerMode: VideoLayer_Mode;

  /**
   * cid (client side id for track) could be different between
   * signalling (AddTrackRequest) and SDP offer. This field
   * will be populated only if it is different to avoid
   * duplication and keep the representation concise.
   *
   * @generated from field: string sdp_cid = 6;
   */
  sdpCid: string;
};

/**
 * Describes the message livekit.SimulcastCodecInfo.
 * Use `create(SimulcastCodecInfoSchema)` to create a new message.
 */
export const SimulcastCodecInfoSchema: GenMessage<SimulcastCodecInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 9);

/**
 * @generated from message livekit.TrackInfo
 */
export type TrackInfo = Message<"livekit.TrackInfo"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * @generated from field: livekit.TrackType type = 2;
   */
  type: TrackType;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bool muted = 4;
   */
  muted: boolean;

  /**
   * original width of video (unset for audio)
   * clients may receive a lower resolution version with simulcast
   *
   * @generated from field: uint32 width = 5;
   */
  width: number;

  /**
   * original height of video (unset for audio)
   *
   * @generated from field: uint32 height = 6;
   */
  height: number;

  /**
   * true if track is simulcasted
   *
   * see `video_layer_mode` in `codecs`
   *
   * @generated from field: bool simulcast = 7 [deprecated = true];
   * @deprecated
   */
  simulcast: boolean;

  /**
   * true if DTX (Discontinuous Transmission) is disabled for audio
   *
   * deprecated in favor of `audio_features`
   *
   * @generated from field: bool disable_dtx = 8 [deprecated = true];
   * @deprecated
   */
  disableDtx: boolean;

  /**
   * source of media
   *
   * @generated from field: livekit.TrackSource source = 9;
   */
  source: TrackSource;

  /**
   * see `codecs` for layers of individual codec
   *
   * @generated from field: repeated livekit.VideoLayer layers = 10 [deprecated = true];
   * @deprecated
   */
  layers: VideoLayer[];

  /**
   * mime type of codec
   *
   * @generated from field: string mime_type = 11;
   */
  mimeType: string;

  /**
   * @generated from field: string mid = 12;
   */
  mid: string;

  /**
   * @generated from field: repeated livekit.SimulcastCodecInfo codecs = 13;
   */
  codecs: SimulcastCodecInfo[];

  /**
   * deprecated in favor of `audio_features`
   *
   * @generated from field: bool stereo = 14 [deprecated = true];
   * @deprecated
   */
  stereo: boolean;

  /**
   * true if RED (Redundant Encoding) is disabled for audio
   *
   * @generated from field: bool disable_red = 15;
   */
  disableRed: boolean;

  /**
   * @generated from field: livekit.Encryption.Type encryption = 16;
   */
  encryption: Encryption_Type;

  /**
   * @generated from field: string stream = 17;
   */
  stream: string;

  /**
   * @generated from field: livekit.TimedVersion version = 18;
   */
  version?: TimedVersion | undefined;

  /**
   * @generated from field: repeated livekit.AudioTrackFeature audio_features = 19;
   */
  audioFeatures: AudioTrackFeature[];

  /**
   * @generated from field: livekit.BackupCodecPolicy backup_codec_policy = 20;
   */
  backupCodecPolicy: BackupCodecPolicy;

  /**
   * @generated from field: repeated livekit.PacketTrailerFeature packet_trailer_features = 21;
   */
  packetTrailerFeatures: PacketTrailerFeature[];
};

/**
 * Describes the message livekit.TrackInfo.
 * Use `create(TrackInfoSchema)` to create a new message.
 */
export const TrackInfoSchema: GenMessage<TrackInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 10);

/**
 * @generated from message livekit.DataTrackInfo
 */
export type DataTrackInfo = Message<"livekit.DataTrackInfo"> & {
  /**
   * Client-assigned, 16-bit identifier that will be attached to packets sent by the publisher.
   *
   * @generated from field: uint32 pub_handle = 1;
   */
  pubHandle: number;

  /**
   * Server-assigned track identifier.
   *
   * @generated from field: string sid = 2;
   */
  sid: string;

  /**
   * Human-readable identifier (e.g., `geoLocation`, `servoPosition.x`, etc.), unique per publisher.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Method used for end-to-end encryption (E2EE) on packet payloads.
   *
   * @generated from field: livekit.Encryption.Type encryption = 4;
   */
  encryption: Encryption_Type;

  /**
   * Encoding for frame payloads on this track. If unspecified, the track is untyped.
   *
   * @generated from field: optional livekit.DataTrackFrameEncoding frame_encoding = 5;
   */
  frameEncoding?: DataTrackFrameEncoding | undefined;

  /**
   * ID of the schema used by frames on this track if the track is typed.
   *
   * @generated from field: optional livekit.DataTrackSchemaId schema = 6;
   */
  schema?: DataTrackSchemaId | undefined;
};

/**
 * Describes the message livekit.DataTrackInfo.
 * Use `create(DataTrackInfoSchema)` to create a new message.
 */
export const DataTrackInfoSchema: GenMessage<DataTrackInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 11);

/**
 * Encoding for frame payloads.
 *
 * @generated from message livekit.DataTrackFrameEncoding
 */
export type DataTrackFrameEncoding = Message<"livekit.DataTrackFrameEncoding"> & {
  /**
   * @generated from oneof livekit.DataTrackFrameEncoding.value
   */
  value: {
    /**
     * @generated from field: livekit.DataTrackFrameEncoding.WellKnownFrameEncoding well_known = 1;
     */
    value: DataTrackFrameEncoding_WellKnownFrameEncoding;
    case: "wellKnown";
  } | {
    /**
     * Identifier of a custom encoding not covered by the well-known cases.
     * This must be non-empty and no longer than 32 characters.
     *
     * @generated from field: string custom = 2;
     */
    value: string;
    case: "custom";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livekit.DataTrackFrameEncoding.
 * Use `create(DataTrackFrameEncodingSchema)` to create a new message.
 */
export const DataTrackFrameEncodingSchema: GenMessage<DataTrackFrameEncoding> = /*@__PURE__*/
  messageDesc(file_livekit_models, 12);

/**
 * Well-known encoding for frame payloads.
 *
 * Mirrors the well-known message encodings from the MCAP spec:
 * https://mcap.dev/spec/registry#message-encodings
 *
 *
 * @generated from enum livekit.DataTrackFrameEncoding.WellKnownFrameEncoding
 */
export enum DataTrackFrameEncoding_WellKnownFrameEncoding {
  /**
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ROS 1: must be described by `ROS1_MSG` schema encoding.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_ROS1 = 1;
   */
  ROS1 = 1,

  /**
   * CDR: must be described by `ROS2_MSG`, `ROS2_IDL`, or `OMG_IDL` schema encoding.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_CDR = 2;
   */
  CDR = 2,

  /**
   * Protocol Buffer: must be described by `PROTOBUF` schema encoding.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_PROTOBUF = 3;
   */
  PROTOBUF = 3,

  /**
   * FlatBuffer: must be described by `FLATBUFFER` schema encoding.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_FLATBUFFER = 4;
   */
  FLATBUFFER = 4,

  /**
   * CBOR: self-describing.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_CBOR = 5;
   */
  CBOR = 5,

  /**
   * MessagePack: self-describing.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_MSGPACK = 6;
   */
  MSGPACK = 6,

  /**
   * JSON: self-describing or described by `JSON_SCHEMA` schema encoding.
   *
   * @generated from enum value: WELL_KNOWN_FRAME_ENCODING_JSON = 7;
   */
  JSON = 7,
}

/**
 * Describes the enum livekit.DataTrackFrameEncoding.WellKnownFrameEncoding.
 */
export const DataTrackFrameEncoding_WellKnownFrameEncodingSchema: GenEnum<DataTrackFrameEncoding_WellKnownFrameEncoding> = /*@__PURE__*/
  enumDesc(file_livekit_models, 12, 0);

/**
 * Encoding for schema definition.
 *
 * @generated from message livekit.DataTrackSchemaEncoding
 */
export type DataTrackSchemaEncoding = Message<"livekit.DataTrackSchemaEncoding"> & {
  /**
   * @generated from oneof livekit.DataTrackSchemaEncoding.value
   */
  value: {
    /**
     * @generated from field: livekit.DataTrackSchemaEncoding.WellKnownSchemaEncoding well_known = 1;
     */
    value: DataTrackSchemaEncoding_WellKnownSchemaEncoding;
    case: "wellKnown";
  } | {
    /**
     * Identifier of a custom encoding not covered by the well-known cases.
     * This must be non-empty and no longer than 32 characters.
     *
     * @generated from field: string custom = 2;
     */
    value: string;
    case: "custom";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livekit.DataTrackSchemaEncoding.
 * Use `create(DataTrackSchemaEncodingSchema)` to create a new message.
 */
export const DataTrackSchemaEncodingSchema: GenMessage<DataTrackSchemaEncoding> = /*@__PURE__*/
  messageDesc(file_livekit_models, 13);

/**
 * Well-known encoding for schema definition.
 *
 * Mirrors the well-known schema encodings from the MCAP spec:
 * https://mcap.dev/spec/registry#schema-encodings
 *
 *
 * @generated from enum livekit.DataTrackSchemaEncoding.WellKnownSchemaEncoding
 */
export enum DataTrackSchemaEncoding_WellKnownSchemaEncoding {
  /**
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Protocol Buffer IDL: describes `PROTOBUF` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_PROTOBUF = 1;
   */
  PROTOBUF = 1,

  /**
   * FlatBuffer IDL: describes `FLATBUFFER` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_FLATBUFFER = 2;
   */
  FLATBUFFER = 2,

  /**
   * ROS 1 Message: describes `ROS1` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_ROS1_MSG = 3;
   */
  ROS1_MSG = 3,

  /**
   * ROS 2 Message: describes `CDR` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_ROS2_MSG = 4;
   */
  ROS2_MSG = 4,

  /**
   * ROS 2 IDL: describes `CDR` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_ROS2_IDL = 5;
   */
  ROS2_IDL = 5,

  /**
   * OMG IDL: describes `CDR` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_OMG_IDL = 6;
   */
  OMG_IDL = 6,

  /**
   * JSON Schema: describes `JSON` frame encoding.
   *
   * @generated from enum value: WELL_KNOWN_SCHEMA_ENCODING_JSON_SCHEMA = 7;
   */
  JSON_SCHEMA = 7,
}

/**
 * Describes the enum livekit.DataTrackSchemaEncoding.WellKnownSchemaEncoding.
 */
export const DataTrackSchemaEncoding_WellKnownSchemaEncodingSchema: GenEnum<DataTrackSchemaEncoding_WellKnownSchemaEncoding> = /*@__PURE__*/
  enumDesc(file_livekit_models, 13, 0);

/**
 * Identifier for a data track schema.
 *
 * Schemas with the same name but different encodings are distinct.
 *
 *
 * @generated from message livekit.DataTrackSchemaId
 */
export type DataTrackSchemaId = Message<"livekit.DataTrackSchemaId"> & {
  /**
   * This must be non-empty and no longer than 256 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: livekit.DataTrackSchemaEncoding encoding = 2;
   */
  encoding?: DataTrackSchemaEncoding | undefined;
};

/**
 * Describes the message livekit.DataTrackSchemaId.
 * Use `create(DataTrackSchemaIdSchema)` to create a new message.
 */
export const DataTrackSchemaIdSchema: GenMessage<DataTrackSchemaId> = /*@__PURE__*/
  messageDesc(file_livekit_models, 14);

/**
 * @generated from message livekit.DataTrackExtensionParticipantSid
 */
export type DataTrackExtensionParticipantSid = Message<"livekit.DataTrackExtensionParticipantSid"> & {
  /**
   * @generated from field: livekit.DataTrackExtensionID id = 1;
   */
  id: DataTrackExtensionID;

  /**
   * @generated from field: string participant_sid = 2;
   */
  participantSid: string;
};

/**
 * Describes the message livekit.DataTrackExtensionParticipantSid.
 * Use `create(DataTrackExtensionParticipantSidSchema)` to create a new message.
 */
export const DataTrackExtensionParticipantSidSchema: GenMessage<DataTrackExtensionParticipantSid> = /*@__PURE__*/
  messageDesc(file_livekit_models, 15);

/**
 * @generated from message livekit.DataTrackSubscriptionOptions
 */
export type DataTrackSubscriptionOptions = Message<"livekit.DataTrackSubscriptionOptions"> & {
  /**
   * Rate in frames per second (FPS) the subscriber wants to receive frames at.
   * If omitted, the subscriber defaults to the publisher's fps
   *
   * @generated from field: optional uint32 target_fps = 1;
   */
  targetFps?: number | undefined;
};

/**
 * Describes the message livekit.DataTrackSubscriptionOptions.
 * Use `create(DataTrackSubscriptionOptionsSchema)` to create a new message.
 */
export const DataTrackSubscriptionOptionsSchema: GenMessage<DataTrackSubscriptionOptions> = /*@__PURE__*/
  messageDesc(file_livekit_models, 16);

/**
 * Key used to uniquely identify a data blob for storage and retrieval.
 *
 * @generated from message livekit.DataBlobKey
 */
export type DataBlobKey = Message<"livekit.DataBlobKey"> & {
  /**
   * @generated from oneof livekit.DataBlobKey.key
   */
  key: {
    /**
     * Generic string key, blob contains arbitrary data.
     *
     * @generated from field: string generic = 1;
     */
    value: string;
    case: "generic";
  } | {
    /**
     * Data track schema identifier, blob contains schema definition.
     *
     * @generated from field: livekit.DataTrackSchemaId schema_id = 2;
     */
    value: DataTrackSchemaId;
    case: "schemaId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livekit.DataBlobKey.
 * Use `create(DataBlobKeySchema)` to create a new message.
 */
export const DataBlobKeySchema: GenMessage<DataBlobKey> = /*@__PURE__*/
  messageDesc(file_livekit_models, 17);

/**
 * A blob of data stored in a room identified by a unique key.
 *
 * @generated from message livekit.DataBlob
 */
export type DataBlob = Message<"livekit.DataBlob"> & {
  /**
   * Unique key the data blob is identified by.
   *
   * @generated from field: livekit.DataBlobKey key = 1;
   */
  key?: DataBlobKey | undefined;

  /**
   * Contents of the data blob. This must not exceed 50 KB.
   *
   * @generated from field: bytes contents = 2;
   */
  contents: Uint8Array;
};

/**
 * Describes the message livekit.DataBlob.
 * Use `create(DataBlobSchema)` to create a new message.
 */
export const DataBlobSchema: GenMessage<DataBlob> = /*@__PURE__*/
  messageDesc(file_livekit_models, 18);

/**
 * provide information about available spatial layers
 *
 * @generated from message livekit.VideoLayer
 */
export type VideoLayer = Message<"livekit.VideoLayer"> & {
  /**
   * for tracks with a single layer, this should be HIGH
   *
   * @generated from field: livekit.VideoQuality quality = 1;
   */
  quality: VideoQuality;

  /**
   * @generated from field: uint32 width = 2;
   */
  width: number;

  /**
   * @generated from field: uint32 height = 3;
   */
  height: number;

  /**
   * target bitrate in bit per second (bps), server will measure actual
   *
   * @generated from field: uint32 bitrate = 4;
   */
  bitrate: number;

  /**
   * @generated from field: uint32 ssrc = 5;
   */
  ssrc: number;

  /**
   * @generated from field: int32 spatial_layer = 6;
   */
  spatialLayer: number;

  /**
   * @generated from field: string rid = 7;
   */
  rid: string;

  /**
   * @generated from field: uint32 repair_ssrc = 8;
   */
  repairSsrc: number;
};

/**
 * Describes the message livekit.VideoLayer.
 * Use `create(VideoLayerSchema)` to create a new message.
 */
export const VideoLayerSchema: GenMessage<VideoLayer> = /*@__PURE__*/
  messageDesc(file_livekit_models, 19);

/**
 * @generated from enum livekit.VideoLayer.Mode
 */
export enum VideoLayer_Mode {
  /**
   * @generated from enum value: MODE_UNUSED = 0;
   */
  MODE_UNUSED = 0,

  /**
   * @generated from enum value: ONE_SPATIAL_LAYER_PER_STREAM = 1;
   */
  ONE_SPATIAL_LAYER_PER_STREAM = 1,

  /**
   * @generated from enum value: MULTIPLE_SPATIAL_LAYERS_PER_STREAM = 2;
   */
  MULTIPLE_SPATIAL_LAYERS_PER_STREAM = 2,

  /**
   * @generated from enum value: ONE_SPATIAL_LAYER_PER_STREAM_INCOMPLETE_RTCP_SR = 3;
   */
  ONE_SPATIAL_LAYER_PER_STREAM_INCOMPLETE_RTCP_SR = 3,
}

/**
 * Describes the enum livekit.VideoLayer.Mode.
 */
export const VideoLayer_ModeSchema: GenEnum<VideoLayer_Mode> = /*@__PURE__*/
  enumDesc(file_livekit_models, 19, 0);

/**
 * new DataPacket API
 *
 * @generated from message livekit.DataPacket
 */
export type DataPacket = Message<"livekit.DataPacket"> & {
  /**
   * @generated from field: livekit.DataPacket.Kind kind = 1 [deprecated = true];
   * @deprecated
   */
  kind: DataPacket_Kind;

  /**
   * participant identity of user that sent the message
   *
   * @generated from field: string participant_identity = 4;
   */
  participantIdentity: string;

  /**
   * identities of participants who will receive the message (sent to all by default)
   *
   * @generated from field: repeated string destination_identities = 5;
   */
  destinationIdentities: string[];

  /**
   * @generated from oneof livekit.DataPacket.value
   */
  value: {
    /**
     * @generated from field: livekit.UserPacket user = 2;
     */
    value: UserPacket;
    case: "user";
  } | {
    /**
     * @generated from field: livekit.ActiveSpeakerUpdate speaker = 3 [deprecated = true];
     * @deprecated
     */
    value: ActiveSpeakerUpdate;
    case: "speaker";
  } | {
    /**
     * @generated from field: livekit.SipDTMF sip_dtmf = 6;
     */
    value: SipDTMF;
    case: "sipDtmf";
  } | {
    /**
     * @generated from field: livekit.Transcription transcription = 7;
     */
    value: Transcription;
    case: "transcription";
  } | {
    /**
     * @generated from field: livekit.MetricsBatch metrics = 8;
     */
    value: MetricsBatch;
    case: "metrics";
  } | {
    /**
     * @generated from field: livekit.ChatMessage chat_message = 9;
     */
    value: ChatMessage;
    case: "chatMessage";
  } | {
    /**
     * @generated from field: livekit.RpcRequest rpc_request = 10;
     */
    value: RpcRequest;
    case: "rpcRequest";
  } | {
    /**
     * @generated from field: livekit.RpcAck rpc_ack = 11;
     */
    value: RpcAck;
    case: "rpcAck";
  } | {
    /**
     * @generated from field: livekit.RpcResponse rpc_response = 12;
     */
    value: RpcResponse;
    case: "rpcResponse";
  } | {
    /**
     * @generated from field: livekit.DataStream.Header stream_header = 13;
     */
    value: DataStream_Header;
    case: "streamHeader";
  } | {
    /**
     * @generated from field: livekit.DataStream.Chunk stream_chunk = 14;
     */
    value: DataStream_Chunk;
    case: "streamChunk";
  } | {
    /**
     * @generated from field: livekit.DataStream.Trailer stream_trailer = 15;
     */
    value: DataStream_Trailer;
    case: "streamTrailer";
  } | {
    /**
     * @generated from field: livekit.EncryptedPacket encrypted_packet = 18;
     */
    value: EncryptedPacket;
    case: "encryptedPacket";
  } | { case: undefined; value?: undefined };

  /**
   * sequence number of reliable packet
   *
   * @generated from field: uint32 sequence = 16;
   */
  sequence: number;

  /**
   * sid of the user that sent the message
   *
   * @generated from field: string participant_sid = 17;
   */
  participantSid: string;
};

/**
 * Describes the message livekit.DataPacket.
 * Use `create(DataPacketSchema)` to create a new message.
 */
export const DataPacketSchema: GenMessage<DataPacket> = /*@__PURE__*/
  messageDesc(file_livekit_models, 20);

/**
 * @generated from enum livekit.DataPacket.Kind
 */
export enum DataPacket_Kind {
  /**
   * @generated from enum value: RELIABLE = 0;
   */
  RELIABLE = 0,

  /**
   * @generated from enum value: LOSSY = 1;
   */
  LOSSY = 1,
}

/**
 * Describes the enum livekit.DataPacket.Kind.
 */
export const DataPacket_KindSchema: GenEnum<DataPacket_Kind> = /*@__PURE__*/
  enumDesc(file_livekit_models, 20, 0);

/**
 * @generated from message livekit.EncryptedPacket
 */
export type EncryptedPacket = Message<"livekit.EncryptedPacket"> & {
  /**
   * @generated from field: livekit.Encryption.Type encryption_type = 1;
   */
  encryptionType: Encryption_Type;

  /**
   * @generated from field: bytes iv = 2;
   */
  iv: Uint8Array;

  /**
   * @generated from field: uint32 key_index = 3;
   */
  keyIndex: number;

  /**
   * This is an encrypted EncryptedPacketPayload message representation
   *
   * @generated from field: bytes encrypted_value = 4;
   */
  encryptedValue: Uint8Array;
};

/**
 * Describes the message livekit.EncryptedPacket.
 * Use `create(EncryptedPacketSchema)` to create a new message.
 */
export const EncryptedPacketSchema: GenMessage<EncryptedPacket> = /*@__PURE__*/
  messageDesc(file_livekit_models, 21);

/**
 * @generated from message livekit.EncryptedPacketPayload
 */
export type EncryptedPacketPayload = Message<"livekit.EncryptedPacketPayload"> & {
  /**
   * @generated from oneof livekit.EncryptedPacketPayload.value
   */
  value: {
    /**
     * @generated from field: livekit.UserPacket user = 1;
     */
    value: UserPacket;
    case: "user";
  } | {
    /**
     * @generated from field: livekit.ChatMessage chat_message = 3;
     */
    value: ChatMessage;
    case: "chatMessage";
  } | {
    /**
     * @generated from field: livekit.RpcRequest rpc_request = 4;
     */
    value: RpcRequest;
    case: "rpcRequest";
  } | {
    /**
     * @generated from field: livekit.RpcAck rpc_ack = 5;
     */
    value: RpcAck;
    case: "rpcAck";
  } | {
    /**
     * @generated from field: livekit.RpcResponse rpc_response = 6;
     */
    value: RpcResponse;
    case: "rpcResponse";
  } | {
    /**
     * @generated from field: livekit.DataStream.Header stream_header = 7;
     */
    value: DataStream_Header;
    case: "streamHeader";
  } | {
    /**
     * @generated from field: livekit.DataStream.Chunk stream_chunk = 8;
     */
    value: DataStream_Chunk;
    case: "streamChunk";
  } | {
    /**
     * @generated from field: livekit.DataStream.Trailer stream_trailer = 9;
     */
    value: DataStream_Trailer;
    case: "streamTrailer";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livekit.EncryptedPacketPayload.
 * Use `create(EncryptedPacketPayloadSchema)` to create a new message.
 */
export const EncryptedPacketPayloadSchema: GenMessage<EncryptedPacketPayload> = /*@__PURE__*/
  messageDesc(file_livekit_models, 22);

/**
 * @generated from message livekit.ActiveSpeakerUpdate
 * @deprecated
 */
export type ActiveSpeakerUpdate = Message<"livekit.ActiveSpeakerUpdate"> & {
  /**
   * @generated from field: repeated livekit.SpeakerInfo speakers = 1;
   */
  speakers: SpeakerInfo[];
};

/**
 * Describes the message livekit.ActiveSpeakerUpdate.
 * Use `create(ActiveSpeakerUpdateSchema)` to create a new message.
 * @deprecated
 */
export const ActiveSpeakerUpdateSchema: GenMessage<ActiveSpeakerUpdate> = /*@__PURE__*/
  messageDesc(file_livekit_models, 23);

/**
 * @generated from message livekit.SpeakerInfo
 */
export type SpeakerInfo = Message<"livekit.SpeakerInfo"> & {
  /**
   * @generated from field: string sid = 1;
   */
  sid: string;

  /**
   * audio level, 0-1.0, 1 is loudest
   *
   * @generated from field: float level = 2;
   */
  level: number;

  /**
   * true if speaker is currently active
   *
   * @generated from field: bool active = 3;
   */
  active: boolean;
};

/**
 * Describes the message livekit.SpeakerInfo.
 * Use `create(SpeakerInfoSchema)` to create a new message.
 */
export const SpeakerInfoSchema: GenMessage<SpeakerInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 24);

/**
 * @generated from message livekit.UserPacket
 */
export type UserPacket = Message<"livekit.UserPacket"> & {
  /**
   * participant ID of user that sent the message
   *
   * @generated from field: string participant_sid = 1 [deprecated = true];
   * @deprecated
   */
  participantSid: string;

  /**
   * @generated from field: string participant_identity = 5 [deprecated = true];
   * @deprecated
   */
  participantIdentity: string;

  /**
   * user defined payload
   *
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;

  /**
   * the ID of the participants who will receive the message (sent to all by default)
   *
   * @generated from field: repeated string destination_sids = 3 [deprecated = true];
   * @deprecated
   */
  destinationSids: string[];

  /**
   * identities of participants who will receive the message (sent to all by default)
   *
   * @generated from field: repeated string destination_identities = 6 [deprecated = true];
   * @deprecated
   */
  destinationIdentities: string[];

  /**
   * topic under which the message was published
   *
   * @generated from field: optional string topic = 4;
   */
  topic?: string | undefined;

  /**
   * Unique ID to identify the message
   *
   * @generated from field: optional string id = 8;
   */
  id?: string | undefined;

  /**
   * start and end time allow relating the message to specific media time
   *
   * @generated from field: optional uint64 start_time = 9 [jstype = JS_STRING];
   */
  startTime?: string | undefined;

  /**
   * @generated from field: optional uint64 end_time = 10 [jstype = JS_STRING];
   */
  endTime?: string | undefined;

  /**
   * added by SDK to enable de-duping of messages, for INTERNAL USE ONLY
   *
   * @generated from field: bytes nonce = 11;
   */
  nonce: Uint8Array;
};

/**
 * Describes the message livekit.UserPacket.
 * Use `create(UserPacketSchema)` to create a new message.
 */
export const UserPacketSchema: GenMessage<UserPacket> = /*@__PURE__*/
  messageDesc(file_livekit_models, 25);

/**
 * @generated from message livekit.SipDTMF
 */
export type SipDTMF = Message<"livekit.SipDTMF"> & {
  /**
   * @generated from field: uint32 code = 3;
   */
  code: number;

  /**
   * @generated from field: string digit = 4;
   */
  digit: string;
};

/**
 * Describes the message livekit.SipDTMF.
 * Use `create(SipDTMFSchema)` to create a new message.
 */
export const SipDTMFSchema: GenMessage<SipDTMF> = /*@__PURE__*/
  messageDesc(file_livekit_models, 26);

/**
 * @generated from message livekit.Transcription
 */
export type Transcription = Message<"livekit.Transcription"> & {
  /**
   * Participant that got its speech transcribed
   *
   * @generated from field: string transcribed_participant_identity = 2;
   */
  transcribedParticipantIdentity: string;

  /**
   * @generated from field: string track_id = 3;
   */
  trackId: string;

  /**
   * @generated from field: repeated livekit.TranscriptionSegment segments = 4;
   */
  segments: TranscriptionSegment[];
};

/**
 * Describes the message livekit.Transcription.
 * Use `create(TranscriptionSchema)` to create a new message.
 */
export const TranscriptionSchema: GenMessage<Transcription> = /*@__PURE__*/
  messageDesc(file_livekit_models, 27);

/**
 * @generated from message livekit.TranscriptionSegment
 */
export type TranscriptionSegment = Message<"livekit.TranscriptionSegment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: uint64 start_time = 3 [jstype = JS_STRING];
   */
  startTime: string;

  /**
   * @generated from field: uint64 end_time = 4 [jstype = JS_STRING];
   */
  endTime: string;

  /**
   * @generated from field: bool final = 5;
   */
  final: boolean;

  /**
   * @generated from field: string language = 6;
   */
  language: string;
};

/**
 * Describes the message livekit.TranscriptionSegment.
 * Use `create(TranscriptionSegmentSchema)` to create a new message.
 */
export const TranscriptionSegmentSchema: GenMessage<TranscriptionSegment> = /*@__PURE__*/
  messageDesc(file_livekit_models, 28);

/**
 * @generated from message livekit.ChatMessage
 */
export type ChatMessage = Message<"livekit.ChatMessage"> & {
  /**
   * uuid
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 timestamp = 2 [jstype = JS_STRING];
   */
  timestamp: string;

  /**
   * populated only if the intent is to edit/update an existing message
   *
   * @generated from field: optional int64 edit_timestamp = 3 [jstype = JS_STRING];
   */
  editTimestamp?: string | undefined;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * true to remove message
   *
   * @generated from field: bool deleted = 5;
   */
  deleted: boolean;

  /**
   * true if the chat message has been generated by an agent from a participant's audio transcription
   *
   * @generated from field: bool generated = 6;
   */
  generated: boolean;
};

/**
 * Describes the message livekit.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_livekit_models, 29);

/**
 * @generated from message livekit.RpcRequest
 */
export type RpcRequest = Message<"livekit.RpcRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string method = 2;
   */
  method: string;

  /**
   * @generated from field: string payload = 3;
   */
  payload: string;

  /**
   * @generated from field: uint32 response_timeout_ms = 4;
   */
  responseTimeoutMs: number;

  /**
   * @generated from field: uint32 version = 5;
   */
  version: number;

  /**
   * Compressed payload data. When set, this field is used instead of `payload`.
   *
   * @generated from field: bytes compressed_payload = 6;
   */
  compressedPayload: Uint8Array;
};

/**
 * Describes the message livekit.RpcRequest.
 * Use `create(RpcRequestSchema)` to create a new message.
 */
export const RpcRequestSchema: GenMessage<RpcRequest> = /*@__PURE__*/
  messageDesc(file_livekit_models, 30);

/**
 * @generated from message livekit.RpcAck
 */
export type RpcAck = Message<"livekit.RpcAck"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;
};

/**
 * Describes the message livekit.RpcAck.
 * Use `create(RpcAckSchema)` to create a new message.
 */
export const RpcAckSchema: GenMessage<RpcAck> = /*@__PURE__*/
  messageDesc(file_livekit_models, 31);

/**
 * @generated from message livekit.RpcResponse
 */
export type RpcResponse = Message<"livekit.RpcResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from oneof livekit.RpcResponse.value
   */
  value: {
    /**
     * @generated from field: string payload = 2;
     */
    value: string;
    case: "payload";
  } | {
    /**
     * @generated from field: livekit.RpcError error = 3;
     */
    value: RpcError;
    case: "error";
  } | {
    /**
     * Compressed payload data. When set, this field is used instead of `payload`.
     *
     * @generated from field: bytes compressed_payload = 4;
     */
    value: Uint8Array;
    case: "compressedPayload";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message livekit.RpcResponse.
 * Use `create(RpcResponseSchema)` to create a new message.
 */
export const RpcResponseSchema: GenMessage<RpcResponse> = /*@__PURE__*/
  messageDesc(file_livekit_models, 32);

/**
 * @generated from message livekit.RpcError
 */
export type RpcError = Message<"livekit.RpcError"> & {
  /**
   * @generated from field: uint32 code = 1;
   */
  code: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string data = 3;
   */
  data: string;
};

/**
 * Describes the message livekit.RpcError.
 * Use `create(RpcErrorSchema)` to create a new message.
 */
export const RpcErrorSchema: GenMessage<RpcError> = /*@__PURE__*/
  messageDesc(file_livekit_models, 33);

/**
 * @generated from message livekit.ParticipantTracks
 */
export type ParticipantTracks = Message<"livekit.ParticipantTracks"> & {
  /**
   * participant ID of participant to whom the tracks belong
   *
   * @generated from field: string participant_sid = 1;
   */
  participantSid: string;

  /**
   * @generated from field: repeated string track_sids = 2;
   */
  trackSids: string[];
};

/**
 * Describes the message livekit.ParticipantTracks.
 * Use `create(ParticipantTracksSchema)` to create a new message.
 */
export const ParticipantTracksSchema: GenMessage<ParticipantTracks> = /*@__PURE__*/
  messageDesc(file_livekit_models, 34);

/**
 * details about the server
 *
 * @generated from message livekit.ServerInfo
 */
export type ServerInfo = Message<"livekit.ServerInfo"> & {
  /**
   * @generated from field: livekit.ServerInfo.Edition edition = 1;
   */
  edition: ServerInfo_Edition;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: int32 protocol = 3;
   */
  protocol: number;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * @generated from field: string node_id = 5;
   */
  nodeId: string;

  /**
   * additional debugging information. sent only if server is in development mode
   *
   * @generated from field: string debug_info = 6;
   */
  debugInfo: string;

  /**
   * @generated from field: int32 agent_protocol = 7;
   */
  agentProtocol: number;
};

/**
 * Describes the message livekit.ServerInfo.
 * Use `create(ServerInfoSchema)` to create a new message.
 */
export const ServerInfoSchema: GenMessage<ServerInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 35);

/**
 * @generated from enum livekit.ServerInfo.Edition
 */
export enum ServerInfo_Edition {
  /**
   * @generated from enum value: Standard = 0;
   */
  Standard = 0,

  /**
   * @generated from enum value: Cloud = 1;
   */
  Cloud = 1,
}

/**
 * Describes the enum livekit.ServerInfo.Edition.
 */
export const ServerInfo_EditionSchema: GenEnum<ServerInfo_Edition> = /*@__PURE__*/
  enumDesc(file_livekit_models, 35, 0);

/**
 * details about the client
 *
 * @generated from message livekit.ClientInfo
 */
export type ClientInfo = Message<"livekit.ClientInfo"> & {
  /**
   * @generated from field: livekit.ClientInfo.SDK sdk = 1;
   */
  sdk: ClientInfo_SDK;

  /**
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * @generated from field: int32 protocol = 3;
   */
  protocol: number;

  /**
   * @generated from field: string os = 4;
   */
  os: string;

  /**
   * @generated from field: string os_version = 5;
   */
  osVersion: string;

  /**
   * @generated from field: string device_model = 6;
   */
  deviceModel: string;

  /**
   * @generated from field: string browser = 7;
   */
  browser: string;

  /**
   * @generated from field: string browser_version = 8;
   */
  browserVersion: string;

  /**
   * @generated from field: string address = 9;
   */
  address: string;

  /**
   * wifi, wired, cellular, vpn, empty if not known
   *
   * @generated from field: string network = 10;
   */
  network: string;

  /**
   * comma separated list of additional LiveKit SDKs in use of this client, with versions
   * e.g. "components-js:1.2.3,track-processors-js:1.2.3"
   *
   * @generated from field: string other_sdks = 11;
   */
  otherSdks: string;

  /**
   * client protocol version
   *
   * @generated from field: int32 client_protocol = 12;
   */
  clientProtocol: number;

  /**
   * capabilities the client advertises. Populated automatically by each SDK;
   * not a user-configurable setting.
   *
   * @generated from field: repeated livekit.ClientInfo.Capability capabilities = 13;
   */
  capabilities: ClientInfo_Capability[];
};

/**
 * Describes the message livekit.ClientInfo.
 * Use `create(ClientInfoSchema)` to create a new message.
 */
export const ClientInfoSchema: GenMessage<ClientInfo> = /*@__PURE__*/
  messageDesc(file_livekit_models, 36);

/**
 * @generated from enum livekit.ClientInfo.SDK
 */
export enum ClientInfo_SDK {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: JS = 1;
   */
  JS = 1,

  /**
   * @generated from enum value: SWIFT = 2;
   */
  SWIFT = 2,

  /**
   * @generated from enum value: ANDROID = 3;
   */
  ANDROID = 3,

  /**
   * @generated from enum value: FLUTTER = 4;
   */
  FLUTTER = 4,

  /**
   * @generated from enum value: GO = 5;
   */
  GO = 5,

  /**
   * @generated from enum value: UNITY = 6;
   */
  UNITY = 6,

  /**
   * @generated from enum value: REACT_NATIVE = 7;
   */
  REACT_NATIVE = 7,

  /**
   * @generated from enum value: RUST = 8;
   */
  RUST = 8,

  /**
   * @generated from enum value: PYTHON = 9;
   */
  PYTHON = 9,

  /**
   * @generated from enum value: CPP = 10;
   */
  CPP = 10,

  /**
   * @generated from enum value: UNITY_WEB = 11;
   */
  UNITY_WEB = 11,

  /**
   * @generated from enum value: NODE = 12;
   */
  NODE = 12,

  /**
   * @generated from enum value: UNREAL = 13;
   */
  UNREAL = 13,

  /**
   * @generated from enum value: ESP32 = 14;
   */
  ESP32 = 14,
}

/**
 * Describes the enum livekit.ClientInfo.SDK.
 */
export const ClientInfo_SDKSchema: GenEnum<ClientInfo_SDK> = /*@__PURE__*/
  enumDesc(file_livekit_models, 36, 0);

/**
 * Optional capabilities advertised by the client at connect time. The SFU
 * uses these flags to decide whether to enable features that require
 * client-side support (e.g. passing RTP packet trailers through to the
 * subscriber instead of stripping them).
 *
 * @generated from enum livekit.ClientInfo.Capability
 */
export enum ClientInfo_Capability {
  /**
   * @generated from enum value: CAP_UNUSED = 0;
   */
  CAP_UNUSED = 0,

  /**
   * @generated from enum value: CAP_PACKET_TRAILER = 1;
   */
  CAP_PACKET_TRAILER = 1,

  /**
   * @generated from enum value: CAP_COMPRESSION_DEFLATE_RAW = 2;
   */
  CAP_COMPRESSION_DEFLATE_RAW = 2,
}

/**
 * Describes the enum livekit.ClientInfo.Capability.
 */
export const ClientInfo_CapabilitySchema: GenEnum<ClientInfo_Capability> = /*@__PURE__*/
  enumDesc(file_livekit_models, 36, 1);

/**
 * server provided client configuration
 *
 * @generated from message livekit.ClientConfiguration
 */
export type ClientConfiguration = Message<"livekit.ClientConfiguration"> & {
  /**
   * @generated from field: livekit.VideoConfiguration video = 1;
   */
  video?: VideoConfiguration | undefined;

  /**
   * @generated from field: livekit.VideoConfiguration screen = 2;
   */
  screen?: VideoConfiguration | undefined;

  /**
   * @generated from field: livekit.ClientConfigSetting resume_connection = 3;
   */
  resumeConnection: ClientConfigSetting;

  /**
   * @generated from field: livekit.DisabledCodecs disabled_codecs = 4;
   */
  disabledCodecs?: DisabledCodecs | undefined;

  /**
   * @generated from field: livekit.ClientConfigSetting force_relay = 5;
   */
  forceRelay: ClientConfigSetting;
};

/**
 * Describes the message livekit.ClientConfiguration.
 * Use `create(ClientConfigurationSchema)` to create a new message.
 */
export const ClientConfigurationSchema: GenMessage<ClientConfiguration> = /*@__PURE__*/
  messageDesc(file_livekit_models, 37);

/**
 * @generated from message livekit.VideoConfiguration
 */
export type VideoConfiguration = Message<"livekit.VideoConfiguration"> & {
  /**
   * @generated from field: livekit.ClientConfigSetting hardware_encoder = 1;
   */
  hardwareEncoder: ClientConfigSetting;
};

/**
 * Describes the message livekit.VideoConfiguration.
 * Use `create(VideoConfigurationSchema)` to create a new message.
 */
export const VideoConfigurationSchema: GenMessage<VideoConfiguration> = /*@__PURE__*/
  messageDesc(file_livekit_models, 38);

/**
 * @generated from message livekit.DisabledCodecs
 */
export type DisabledCodecs = Message<"livekit.DisabledCodecs"> & {
  /**
   * disabled for both publish and subscribe
   *
   * @generated from field: repeated livekit.Codec codecs = 1;
   */
  codecs: Codec[];

  /**
   * only disable for publish
   *
   * @generated from field: repeated livekit.Codec publish = 2;
   */
  publish: Codec[];
};

/**
 * Describes the message livekit.DisabledCodecs.
 * Use `create(DisabledCodecsSchema)` to create a new message.
 */
export const DisabledCodecsSchema: GenMessage<DisabledCodecs> = /*@__PURE__*/
  messageDesc(file_livekit_models, 39);

/**
 * @generated from message livekit.RTPDrift
 */
export type RTPDrift = Message<"livekit.RTPDrift"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: double duration = 3;
   */
  duration: number;

  /**
   * @generated from field: uint64 start_timestamp = 4 [jstype = JS_STRING];
   */
  startTimestamp: string;

  /**
   * @generated from field: uint64 end_timestamp = 5 [jstype = JS_STRING];
   */
  endTimestamp: string;

  /**
   * @generated from field: uint64 rtp_clock_ticks = 6 [jstype = JS_STRING];
   */
  rtpClockTicks: string;

  /**
   * @generated from field: int64 drift_samples = 7 [jstype = JS_STRING];
   */
  driftSamples: string;

  /**
   * @generated from field: double drift_ms = 8;
   */
  driftMs: number;

  /**
   * @generated from field: double clock_rate = 9;
   */
  clockRate: number;
};

/**
 * Describes the message livekit.RTPDrift.
 * Use `create(RTPDriftSchema)` to create a new message.
 */
export const RTPDriftSchema: GenMessage<RTPDrift> = /*@__PURE__*/
  messageDesc(file_livekit_models, 40);

/**
 * @generated from message livekit.RTPStats
 */
export type RTPStats = Message<"livekit.RTPStats"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp | undefined;

  /**
   * @generated from field: double duration = 3;
   */
  duration: number;

  /**
   * @generated from field: uint32 packets = 4;
   */
  packets: number;

  /**
   * @generated from field: double packet_rate = 5;
   */
  packetRate: number;

  /**
   * @generated from field: uint64 bytes = 6 [jstype = JS_STRING];
   */
  bytes: string;

  /**
   * @generated from field: uint64 header_bytes = 39 [jstype = JS_STRING];
   */
  headerBytes: string;

  /**
   * @generated from field: double bitrate = 7;
   */
  bitrate: number;

  /**
   * @generated from field: uint32 packets_lost = 8;
   */
  packetsLost: number;

  /**
   * @generated from field: double packet_loss_rate = 9;
   */
  packetLossRate: number;

  /**
   * @generated from field: float packet_loss_percentage = 10;
   */
  packetLossPercentage: number;

  /**
   * @generated from field: uint32 packets_duplicate = 11;
   */
  packetsDuplicate: number;

  /**
   * @generated from field: double packet_duplicate_rate = 12;
   */
  packetDuplicateRate: number;

  /**
   * @generated from field: uint64 bytes_duplicate = 13 [jstype = JS_STRING];
   */
  bytesDuplicate: string;

  /**
   * @generated from field: uint64 header_bytes_duplicate = 40 [jstype = JS_STRING];
   */
  headerBytesDuplicate: string;

  /**
   * @generated from field: double bitrate_duplicate = 14;
   */
  bitrateDuplicate: number;

  /**
   * @generated from field: uint32 packets_padding = 15;
   */
  packetsPadding: number;

  /**
   * @generated from field: double packet_padding_rate = 16;
   */
  packetPaddingRate: number;

  /**
   * @generated from field: uint64 bytes_padding = 17 [jstype = JS_STRING];
   */
  bytesPadding: string;

  /**
   * @generated from field: uint64 header_bytes_padding = 41 [jstype = JS_STRING];
   */
  headerBytesPadding: string;

  /**
   * @generated from field: double bitrate_padding = 18;
   */
  bitratePadding: number;

  /**
   * @generated from field: uint32 packets_out_of_order = 19;
   */
  packetsOutOfOrder: number;

  /**
   * @generated from field: uint32 frames = 20;
   */
  frames: number;

  /**
   * @generated from field: double frame_rate = 21;
   */
  frameRate: number;

  /**
   * @generated from field: double jitter_current = 22;
   */
  jitterCurrent: number;

  /**
   * @generated from field: double jitter_max = 23;
   */
  jitterMax: number;

  /**
   * @generated from field: map<int32, uint32> gap_histogram = 24;
   */
  gapHistogram: { [key: number]: number };

  /**
   * @generated from field: uint32 nacks = 25;
   */
  nacks: number;

  /**
   * @generated from field: uint32 nack_acks = 37;
   */
  nackAcks: number;

  /**
   * @generated from field: uint32 nack_misses = 26;
   */
  nackMisses: number;

  /**
   * @generated from field: uint32 nack_repeated = 38;
   */
  nackRepeated: number;

  /**
   * @generated from field: uint32 plis = 27;
   */
  plis: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_pli = 28;
   */
  lastPli?: Timestamp | undefined;

  /**
   * @generated from field: uint32 firs = 29;
   */
  firs: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_fir = 30;
   */
  lastFir?: Timestamp | undefined;

  /**
   * @generated from field: uint32 rtt_current = 31;
   */
  rttCurrent: number;

  /**
   * @generated from field: uint32 rtt_max = 32;
   */
  rttMax: number;

  /**
   * @generated from field: uint32 key_frames = 33;
   */
  keyFrames: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_key_frame = 34;
   */
  lastKeyFrame?: Timestamp | undefined;

  /**
   * @generated from field: uint32 layer_lock_plis = 35;
   */
  layerLockPlis: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_layer_lock_pli = 36;
   */
  lastLayerLockPli?: Timestamp | undefined;

  /**
   * @generated from field: livekit.RTPDrift packet_drift = 44;
   */
  packetDrift?: RTPDrift | undefined;

  /**
   * @generated from field: livekit.RTPDrift ntp_report_drift = 45;
   */
  ntpReportDrift?: RTPDrift | undefined;

  /**
   * @generated from field: livekit.RTPDrift rebased_report_drift = 46;
   */
  rebasedReportDrift?: RTPDrift | undefined;

  /**
   * NEXT_ID: 48
   *
   * @generated from field: livekit.RTPDrift received_report_drift = 47;
   */
  receivedReportDrift?: RTPDrift | undefined;
};

/**
 * Describes the message livekit.RTPStats.
 * Use `create(RTPStatsSchema)` to create a new message.
 */
export const RTPStatsSchema: GenMessage<RTPStats> = /*@__PURE__*/
  messageDesc(file_livekit_models, 41);

/**
 * @generated from message livekit.RTCPSenderReportState
 */
export type RTCPSenderReportState = Message<"livekit.RTCPSenderReportState"> & {
  /**
   * @generated from field: uint32 rtp_timestamp = 1;
   */
  rtpTimestamp: number;

  /**
   * @generated from field: uint64 rtp_timestamp_ext = 2 [jstype = JS_STRING];
   */
  rtpTimestampExt: string;

  /**
   * @generated from field: uint64 ntp_timestamp = 3 [jstype = JS_STRING];
   */
  ntpTimestamp: string;

  /**
   * time at which this happened
   *
   * @generated from field: int64 at = 4 [jstype = JS_STRING];
   */
  at: string;

  /**
   * @generated from field: int64 at_adjusted = 5 [jstype = JS_STRING];
   */
  atAdjusted: string;

  /**
   * @generated from field: uint32 packets = 6;
   */
  packets: number;

  /**
   * @generated from field: uint64 octets = 7 [jstype = JS_STRING];
   */
  octets: string;
};

/**
 * Describes the message livekit.RTCPSenderReportState.
 * Use `create(RTCPSenderReportStateSchema)` to create a new message.
 */
export const RTCPSenderReportStateSchema: GenMessage<RTCPSenderReportState> = /*@__PURE__*/
  messageDesc(file_livekit_models, 42);

/**
 * @generated from message livekit.RTPForwarderState
 */
export type RTPForwarderState = Message<"livekit.RTPForwarderState"> & {
  /**
   * @generated from field: bool started = 1;
   */
  started: boolean;

  /**
   * @generated from field: int32 reference_layer_spatial = 2;
   */
  referenceLayerSpatial: number;

  /**
   * @generated from field: int64 pre_start_time = 3 [jstype = JS_STRING];
   */
  preStartTime: string;

  /**
   * @generated from field: uint64 ext_first_timestamp = 4 [jstype = JS_STRING];
   */
  extFirstTimestamp: string;

  /**
   * @generated from field: uint64 dummy_start_timestamp_offset = 5 [jstype = JS_STRING];
   */
  dummyStartTimestampOffset: string;

  /**
   * @generated from field: livekit.RTPMungerState rtp_munger = 6;
   */
  rtpMunger?: RTPMungerState | undefined;

  /**
   * @generated from oneof livekit.RTPForwarderState.codec_munger
   */
  codecMunger: {
    /**
     * @generated from field: livekit.VP8MungerState vp8_munger = 7;
     */
    value: VP8MungerState;
    case: "vp8Munger";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: repeated livekit.RTCPSenderReportState sender_report_state = 8;
   */
  senderReportState: RTCPSenderReportState[];
};

/**
 * Describes the message livekit.RTPForwarderState.
 * Use `create(RTPForwarderStateSchema)` to create a new message.
 */
export const RTPForwarderStateSchema: GenMessage<RTPForwarderState> = /*@__PURE__*/
  messageDesc(file_livekit_models, 43);

/**
 * @generated from message livekit.RTPMungerState
 */
export type RTPMungerState = Message<"livekit.RTPMungerState"> & {
  /**
   * @generated from field: uint64 ext_last_sequence_number = 1 [jstype = JS_STRING];
   */
  extLastSequenceNumber: string;

  /**
   * @generated from field: uint64 ext_second_last_sequence_number = 2 [jstype = JS_STRING];
   */
  extSecondLastSequenceNumber: string;

  /**
   * @generated from field: uint64 ext_last_timestamp = 3 [jstype = JS_STRING];
   */
  extLastTimestamp: string;

  /**
   * @generated from field: uint64 ext_second_last_timestamp = 4 [jstype = JS_STRING];
   */
  extSecondLastTimestamp: string;

  /**
   * @generated from field: bool last_marker = 5;
   */
  lastMarker: boolean;

  /**
   * @generated from field: bool second_last_marker = 6;
   */
  secondLastMarker: boolean;
};

/**
 * Describes the message livekit.RTPMungerState.
 * Use `create(RTPMungerStateSchema)` to create a new message.
 */
export const RTPMungerStateSchema: GenMessage<RTPMungerState> = /*@__PURE__*/
  messageDesc(file_livekit_models, 44);

/**
 * @generated from message livekit.VP8MungerState
 */
export type VP8MungerState = Message<"livekit.VP8MungerState"> & {
  /**
   * @generated from field: int32 ext_last_picture_id = 1;
   */
  extLastPictureId: number;

  /**
   * @generated from field: bool picture_id_used = 2;
   */
  pictureIdUsed: boolean;

  /**
   * @generated from field: uint32 last_tl0_pic_idx = 3;
   */
  lastTl0PicIdx: number;

  /**
   * @generated from field: bool tl0_pic_idx_used = 4;
   */
  tl0PicIdxUsed: boolean;

  /**
   * @generated from field: bool tid_used = 5;
   */
  tidUsed: boolean;

  /**
   * @generated from field: uint32 last_key_idx = 6;
   */
  lastKeyIdx: number;

  /**
   * @generated from field: bool key_idx_used = 7;
   */
  keyIdxUsed: boolean;
};

/**
 * Describes the message livekit.VP8MungerState.
 * Use `create(VP8MungerStateSchema)` to create a new message.
 */
export const VP8MungerStateSchema: GenMessage<VP8MungerState> = /*@__PURE__*/
  messageDesc(file_livekit_models, 45);

/**
 * @generated from message livekit.TimedVersion
 */
export type TimedVersion = Message<"livekit.TimedVersion"> & {
  /**
   * @generated from field: int64 unix_micro = 1 [jstype = JS_STRING];
   */
  unixMicro: string;

  /**
   * @generated from field: int32 ticks = 2;
   */
  ticks: number;
};

/**
 * Describes the message livekit.TimedVersion.
 * Use `create(TimedVersionSchema)` to create a new message.
 */
export const TimedVersionSchema: GenMessage<TimedVersion> = /*@__PURE__*/
  messageDesc(file_livekit_models, 46);

/**
 * @generated from message livekit.DataStream
 */
export type DataStream = Message<"livekit.DataStream"> & {
};

/**
 * Describes the message livekit.DataStream.
 * Use `create(DataStreamSchema)` to create a new message.
 */
export const DataStreamSchema: GenMessage<DataStream> = /*@__PURE__*/
  messageDesc(file_livekit_models, 47);

/**
 * header properties specific to text streams
 *
 * @generated from message livekit.DataStream.TextHeader
 */
export type DataStream_TextHeader = Message<"livekit.DataStream.TextHeader"> & {
  /**
   * @generated from field: livekit.DataStream.OperationType operation_type = 1;
   */
  operationType: DataStream_OperationType;

  /**
   * Optional: Version for updates/edits
   *
   * @generated from field: int32 version = 2;
   */
  version: number;

  /**
   * Optional: Reply to specific message
   *
   * @generated from field: string reply_to_stream_id = 3;
   */
  replyToStreamId: string;

  /**
   * file attachments for text streams
   *
   * @generated from field: repeated string attached_stream_ids = 4;
   */
  attachedStreamIds: string[];

  /**
   * true if the text has been generated by an agent from a participant's audio transcription
   *
   * @generated from field: bool generated = 5;
   */
  generated: boolean;
};

/**
 * Describes the message livekit.DataStream.TextHeader.
 * Use `create(DataStream_TextHeaderSchema)` to create a new message.
 */
export const DataStream_TextHeaderSchema: GenMessage<DataStream_TextHeader> = /*@__PURE__*/
  messageDesc(file_livekit_models, 47, 0);

/**
 * header properties specific to byte or file streams
 *
 * @generated from message livekit.DataStream.ByteHeader
 */
export type DataStream_ByteHeader = Message<"livekit.DataStream.ByteHeader"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message livekit.DataStream.ByteHeader.
 * Use `create(DataStream_ByteHeaderSchema)` to create a new message.
 */
export const DataStream_ByteHeaderSchema: GenMessage<DataStream_ByteHeader> = /*@__PURE__*/
  messageDesc(file_livekit_models, 47, 1);

/**
 * main DataStream.Header that contains a oneof for specific headers
 *
 * @generated from message livekit.DataStream.Header
 */
export type DataStream_Header = Message<"livekit.DataStream.Header"> & {
  /**
   * unique identifier for this data stream
   *
   * @generated from field: string stream_id = 1;
   */
  streamId: string;

  /**
   * using int64 for Unix timestamp
   *
   * @generated from field: int64 timestamp = 2 [jstype = JS_STRING];
   */
  timestamp: string;

  /**
   * @generated from field: string topic = 3;
   */
  topic: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;

  /**
   * only populated for finite streams, if it's a stream of unknown size this stays empty
   *
   * @generated from field: optional uint64 total_length = 5 [jstype = JS_STRING];
   */
  totalLength?: string | undefined;

  /**
   *  this is set on the DataPacket
   *
   * @generated from field: livekit.Encryption.Type encryption_type = 7 [deprecated = true];
   * @deprecated
   */
  encryptionType: Encryption_Type;

  /**
   * user defined attributes map that can carry additional info
   *
   * @generated from field: map<string, string> attributes = 8;
   */
  attributes: { [key: string]: string };

  /**
   * oneof to choose between specific header types
   *
   * @generated from oneof livekit.DataStream.Header.content_header
   */
  contentHeader: {
    /**
     * @generated from field: livekit.DataStream.TextHeader text_header = 9;
     */
    value: DataStream_TextHeader;
    case: "textHeader";
  } | {
    /**
     * @generated from field: livekit.DataStream.ByteHeader byte_header = 10;
     */
    value: DataStream_ByteHeader;
    case: "byteHeader";
  } | { case: undefined; value?: undefined };

  /**
   * Optional inline content so that a data stream can be sent as a single packet for short payloads.
   *
   * content as binary (bytes)
   *
   * @generated from field: optional bytes inline_content = 11;
   */
  inlineContent?: Uint8Array | undefined;

  /**
   * @generated from field: livekit.DataStream.CompressionType compression = 12;
   */
  compression: DataStream_CompressionType;
};

/**
 * Describes the message livekit.DataStream.Header.
 * Use `create(DataStream_HeaderSchema)` to create a new message.
 */
export const DataStream_HeaderSchema: GenMessage<DataStream_Header> = /*@__PURE__*/
  messageDesc(file_livekit_models, 47, 2);

/**
 * @generated from message livekit.DataStream.Chunk
 */
export type DataStream_Chunk = Message<"livekit.DataStream.Chunk"> & {
  /**
   * unique identifier for this data stream to map it to the correct header
   *
   * @generated from field: string stream_id = 1;
   */
  streamId: string;

  /**
   * @generated from field: uint64 chunk_index = 2 [jstype = JS_STRING];
   */
  chunkIndex: string;

  /**
   * content as binary (bytes)
   *
   * @generated from field: bytes content = 3;
   */
  content: Uint8Array;

  /**
   * a version indicating that this chunk_index has been retroactively modified and the original one needs to be replaced
   *
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * this is set on the DataPacket
   *
   * @generated from field: optional bytes iv = 5 [deprecated = true];
   * @deprecated
   */
  iv?: Uint8Array | undefined;
};

/**
 * Describes the message livekit.DataStream.Chunk.
 * Use `create(DataStream_ChunkSchema)` to create a new message.
 */
export const DataStream_ChunkSchema: GenMessage<DataStream_Chunk> = /*@__PURE__*/
  messageDesc(file_livekit_models, 47, 3);

/**
 * @generated from message livekit.DataStream.Trailer
 */
export type DataStream_Trailer = Message<"livekit.DataStream.Trailer"> & {
  /**
   * unique identifier for this data stream
   *
   * @generated from field: string stream_id = 1;
   */
  streamId: string;

  /**
   * reason why the stream was closed (could contain "error" / "interrupted" / empty for expected end)
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * finalizing updates for the stream, can also include additional insights for errors or endTime for transcription
   *
   * @generated from field: map<string, string> attributes = 3;
   */
  attributes: { [key: string]: string };
};

/**
 * Describes the message livekit.DataStream.Trailer.
 * Use `create(DataStream_TrailerSchema)` to create a new message.
 */
export const DataStream_TrailerSchema: GenMessage<DataStream_Trailer> = /*@__PURE__*/
  messageDesc(file_livekit_models, 47, 4);

/**
 * enum for operation types (specific to TextHeader)
 *
 * @generated from enum livekit.DataStream.OperationType
 */
export enum DataStream_OperationType {
  /**
   * @generated from enum value: CREATE = 0;
   */
  CREATE = 0,

  /**
   * @generated from enum value: UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * @generated from enum value: DELETE = 2;
   */
  DELETE = 2,

  /**
   * @generated from enum value: REACTION = 3;
   */
  REACTION = 3,
}

/**
 * Describes the enum livekit.DataStream.OperationType.
 */
export const DataStream_OperationTypeSchema: GenEnum<DataStream_OperationType> = /*@__PURE__*/
  enumDesc(file_livekit_models, 47, 0);

/**
 * The compression type of the whole data stream
 *
 * This will only get populated when send to participants with a
 * client protocol >= 2 which advertise a client capability of CAP_COMPRESSION_DEFLATE_RAW
 *
 * @generated from enum livekit.DataStream.CompressionType
 */
export enum DataStream_CompressionType {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * DEFLATE_RAW = DEFLATE without header+checksum/trailer
   *
   * @generated from enum value: DEFLATE_RAW = 1;
   */
  DEFLATE_RAW = 1,
}

/**
 * Describes the enum livekit.DataStream.CompressionType.
 */
export const DataStream_CompressionTypeSchema: GenEnum<DataStream_CompressionType> = /*@__PURE__*/
  enumDesc(file_livekit_models, 47, 1);

/**
 * @generated from message livekit.FilterParams
 */
export type FilterParams = Message<"livekit.FilterParams"> & {
  /**
   * @generated from field: repeated string include_events = 1;
   */
  includeEvents: string[];

  /**
   * @generated from field: repeated string exclude_events = 2;
   */
  excludeEvents: string[];
};

/**
 * Describes the message livekit.FilterParams.
 * Use `create(FilterParamsSchema)` to create a new message.
 */
export const FilterParamsSchema: GenMessage<FilterParams> = /*@__PURE__*/
  messageDesc(file_livekit_models, 48);

/**
 * @generated from message livekit.WebhookConfig
 */
export type WebhookConfig = Message<"livekit.WebhookConfig"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string signing_key = 2;
   */
  signingKey: string;

  /**
   * @generated from field: livekit.FilterParams filter_params = 3;
   */
  filterParams?: FilterParams | undefined;
};

/**
 * Describes the message livekit.WebhookConfig.
 * Use `create(WebhookConfigSchema)` to create a new message.
 */
export const WebhookConfigSchema: GenMessage<WebhookConfig> = /*@__PURE__*/
  messageDesc(file_livekit_models, 49);

/**
 * @generated from message livekit.SubscribedAudioCodec
 */
export type SubscribedAudioCodec = Message<"livekit.SubscribedAudioCodec"> & {
  /**
   * @generated from field: string codec = 1;
   */
  codec: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message livekit.SubscribedAudioCodec.
 * Use `create(SubscribedAudioCodecSchema)` to create a new message.
 */
export const SubscribedAudioCodecSchema: GenMessage<SubscribedAudioCodec> = /*@__PURE__*/
  messageDesc(file_livekit_models, 50);

/**
 * @generated from enum livekit.AudioCodec
 */
export enum AudioCodec {
  /**
   * @generated from enum value: DEFAULT_AC = 0;
   */
  DEFAULT_AC = 0,

  /**
   * @generated from enum value: OPUS = 1;
   */
  OPUS = 1,

  /**
   * @generated from enum value: AAC = 2;
   */
  AAC = 2,

  /**
   * @generated from enum value: AC_MP3 = 3;
   */
  AC_MP3 = 3,
}

/**
 * Describes the enum livekit.AudioCodec.
 */
export const AudioCodecSchema: GenEnum<AudioCodec> = /*@__PURE__*/
  enumDesc(file_livekit_models, 0);

/**
 * @generated from enum livekit.VideoCodec
 */
export enum VideoCodec {
  /**
   * @generated from enum value: DEFAULT_VC = 0;
   */
  DEFAULT_VC = 0,

  /**
   * @generated from enum value: H264_BASELINE = 1;
   */
  H264_BASELINE = 1,

  /**
   * @generated from enum value: H264_MAIN = 2;
   */
  H264_MAIN = 2,

  /**
   * @generated from enum value: H264_HIGH = 3;
   */
  H264_HIGH = 3,

  /**
   * @generated from enum value: VP8 = 4;
   */
  VP8 = 4,
}

/**
 * Describes the enum livekit.VideoCodec.
 */
export const VideoCodecSchema: GenEnum<VideoCodec> = /*@__PURE__*/
  enumDesc(file_livekit_models, 1);

/**
 * @generated from enum livekit.ImageCodec
 */
export enum ImageCodec {
  /**
   * @generated from enum value: IC_DEFAULT = 0;
   */
  IC_DEFAULT = 0,

  /**
   * @generated from enum value: IC_JPEG = 1;
   */
  IC_JPEG = 1,
}

/**
 * Describes the enum livekit.ImageCodec.
 */
export const ImageCodecSchema: GenEnum<ImageCodec> = /*@__PURE__*/
  enumDesc(file_livekit_models, 2);

/**
 * Policy for publisher to handle subscribers that are unable to support the primary codec of a track
 *
 * @generated from enum livekit.BackupCodecPolicy
 */
export enum BackupCodecPolicy {
  /**
   * default behavior, the track prefer to regress to backup codec and all subscribers will receive the backup codec,
   * the sfu will try to regress codec if possible but not assured.
   *
   * @generated from enum value: PREFER_REGRESSION = 0;
   */
  PREFER_REGRESSION = 0,

  /**
   * encoding/send the primary and backup codec simultaneously
   *
   * @generated from enum value: SIMULCAST = 1;
   */
  SIMULCAST = 1,

  /**
   * force the track to regress to backup codec, this option can be used in video conference or the publisher has limited bandwidth/encoding power
   *
   * @generated from enum value: REGRESSION = 2;
   */
  REGRESSION = 2,
}

/**
 * Describes the enum livekit.BackupCodecPolicy.
 */
export const BackupCodecPolicySchema: GenEnum<BackupCodecPolicy> = /*@__PURE__*/
  enumDesc(file_livekit_models, 3);

/**
 * @generated from enum livekit.TrackType
 */
export enum TrackType {
  /**
   * @generated from enum value: AUDIO = 0;
   */
  AUDIO = 0,

  /**
   * @generated from enum value: VIDEO = 1;
   */
  VIDEO = 1,

  /**
   * @generated from enum value: DATA = 2;
   */
  DATA = 2,
}

/**
 * Describes the enum livekit.TrackType.
 */
export const TrackTypeSchema: GenEnum<TrackType> = /*@__PURE__*/
  enumDesc(file_livekit_models, 4);

/**
 * @generated from enum livekit.TrackSource
 */
export enum TrackSource {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CAMERA = 1;
   */
  CAMERA = 1,

  /**
   * @generated from enum value: MICROPHONE = 2;
   */
  MICROPHONE = 2,

  /**
   * @generated from enum value: SCREEN_SHARE = 3;
   */
  SCREEN_SHARE = 3,

  /**
   * @generated from enum value: SCREEN_SHARE_AUDIO = 4;
   */
  SCREEN_SHARE_AUDIO = 4,
}

/**
 * Describes the enum livekit.TrackSource.
 */
export const TrackSourceSchema: GenEnum<TrackSource> = /*@__PURE__*/
  enumDesc(file_livekit_models, 5);

/**
 * @generated from enum livekit.DataTrackExtensionID
 */
export enum DataTrackExtensionID {
  /**
   * @generated from enum value: DTEI_INVALID = 0;
   */
  DTEI_INVALID = 0,

  /**
   * @generated from enum value: DTEI_PARTICIPANT_SID = 1;
   */
  DTEI_PARTICIPANT_SID = 1,
}

/**
 * Describes the enum livekit.DataTrackExtensionID.
 */
export const DataTrackExtensionIDSchema: GenEnum<DataTrackExtensionID> = /*@__PURE__*/
  enumDesc(file_livekit_models, 6);

/**
 * @generated from enum livekit.VideoQuality
 */
export enum VideoQuality {
  /**
   * @generated from enum value: LOW = 0;
   */
  LOW = 0,

  /**
   * @generated from enum value: MEDIUM = 1;
   */
  MEDIUM = 1,

  /**
   * @generated from enum value: HIGH = 2;
   */
  HIGH = 2,

  /**
   * @generated from enum value: OFF = 3;
   */
  OFF = 3,
}

/**
 * Describes the enum livekit.VideoQuality.
 */
export const VideoQualitySchema: GenEnum<VideoQuality> = /*@__PURE__*/
  enumDesc(file_livekit_models, 7);

/**
 * @generated from enum livekit.ConnectionQuality
 */
export enum ConnectionQuality {
  /**
   * @generated from enum value: POOR = 0;
   */
  POOR = 0,

  /**
   * @generated from enum value: GOOD = 1;
   */
  GOOD = 1,

  /**
   * @generated from enum value: EXCELLENT = 2;
   */
  EXCELLENT = 2,

  /**
   * @generated from enum value: LOST = 3;
   */
  LOST = 3,
}

/**
 * Describes the enum livekit.ConnectionQuality.
 */
export const ConnectionQualitySchema: GenEnum<ConnectionQuality> = /*@__PURE__*/
  enumDesc(file_livekit_models, 8);

/**
 * @generated from enum livekit.ClientConfigSetting
 */
export enum ClientConfigSetting {
  /**
   * @generated from enum value: UNSET = 0;
   */
  UNSET = 0,

  /**
   * @generated from enum value: DISABLED = 1;
   */
  DISABLED = 1,

  /**
   * @generated from enum value: ENABLED = 2;
   */
  ENABLED = 2,
}

/**
 * Describes the enum livekit.ClientConfigSetting.
 */
export const ClientConfigSettingSchema: GenEnum<ClientConfigSetting> = /*@__PURE__*/
  enumDesc(file_livekit_models, 9);

/**
 * @generated from enum livekit.DisconnectReason
 */
export enum DisconnectReason {
  /**
   * @generated from enum value: UNKNOWN_REASON = 0;
   */
  UNKNOWN_REASON = 0,

  /**
   * the client initiated the disconnect
   *
   * @generated from enum value: CLIENT_INITIATED = 1;
   */
  CLIENT_INITIATED = 1,

  /**
   * another participant with the same identity has joined the room
   *
   * @generated from enum value: DUPLICATE_IDENTITY = 2;
   */
  DUPLICATE_IDENTITY = 2,

  /**
   * the server instance is shutting down
   *
   * @generated from enum value: SERVER_SHUTDOWN = 3;
   */
  SERVER_SHUTDOWN = 3,

  /**
   * RoomService.RemoveParticipant was called
   *
   * @generated from enum value: PARTICIPANT_REMOVED = 4;
   */
  PARTICIPANT_REMOVED = 4,

  /**
   * RoomService.DeleteRoom was called
   *
   * @generated from enum value: ROOM_DELETED = 5;
   */
  ROOM_DELETED = 5,

  /**
   * the client is attempting to resume a session, but server is not aware of it
   *
   * @generated from enum value: STATE_MISMATCH = 6;
   */
  STATE_MISMATCH = 6,

  /**
   * client was unable to connect fully
   *
   * @generated from enum value: JOIN_FAILURE = 7;
   */
  JOIN_FAILURE = 7,

  /**
   * Cloud-only, the server requested Participant to migrate the connection elsewhere
   *
   * @generated from enum value: MIGRATION = 8;
   */
  MIGRATION = 8,

  /**
   * the signal websocket was closed unexpectedly
   *
   * @generated from enum value: SIGNAL_CLOSE = 9;
   */
  SIGNAL_CLOSE = 9,

  /**
   * the room was closed, due to all Standard and Ingress participants having left
   *
   * @generated from enum value: ROOM_CLOSED = 10;
   */
  ROOM_CLOSED = 10,

  /**
   * SIP callee did not respond in time
   *
   * @generated from enum value: USER_UNAVAILABLE = 11;
   */
  USER_UNAVAILABLE = 11,

  /**
   * SIP callee rejected the call (busy)
   *
   * @generated from enum value: USER_REJECTED = 12;
   */
  USER_REJECTED = 12,

  /**
   * SIP protocol failure or unexpected response
   *
   * @generated from enum value: SIP_TRUNK_FAILURE = 13;
   */
  SIP_TRUNK_FAILURE = 13,

  /**
   * server timed out a participant session
   *
   * @generated from enum value: CONNECTION_TIMEOUT = 14;
   */
  CONNECTION_TIMEOUT = 14,

  /**
   * media stream failure or media timeout
   *
   * @generated from enum value: MEDIA_FAILURE = 15;
   */
  MEDIA_FAILURE = 15,

  /**
   * agent encountered an error
   *
   * @generated from enum value: AGENT_ERROR = 16;
   */
  AGENT_ERROR = 16,
}

/**
 * Describes the enum livekit.DisconnectReason.
 */
export const DisconnectReasonSchema: GenEnum<DisconnectReason> = /*@__PURE__*/
  enumDesc(file_livekit_models, 10);

/**
 * @generated from enum livekit.ReconnectReason
 */
export enum ReconnectReason {
  /**
   * @generated from enum value: RR_UNKNOWN = 0;
   */
  RR_UNKNOWN = 0,

  /**
   * @generated from enum value: RR_SIGNAL_DISCONNECTED = 1;
   */
  RR_SIGNAL_DISCONNECTED = 1,

  /**
   * @generated from enum value: RR_PUBLISHER_FAILED = 2;
   */
  RR_PUBLISHER_FAILED = 2,

  /**
   * @generated from enum value: RR_SUBSCRIBER_FAILED = 3;
   */
  RR_SUBSCRIBER_FAILED = 3,

  /**
   * @generated from enum value: RR_SWITCH_CANDIDATE = 4;
   */
  RR_SWITCH_CANDIDATE = 4,
}

/**
 * Describes the enum livekit.ReconnectReason.
 */
export const ReconnectReasonSchema: GenEnum<ReconnectReason> = /*@__PURE__*/
  enumDesc(file_livekit_models, 11);

/**
 * @generated from enum livekit.SubscriptionError
 */
export enum SubscriptionError {
  /**
   * @generated from enum value: SE_UNKNOWN = 0;
   */
  SE_UNKNOWN = 0,

  /**
   * @generated from enum value: SE_CODEC_UNSUPPORTED = 1;
   */
  SE_CODEC_UNSUPPORTED = 1,

  /**
   * @generated from enum value: SE_TRACK_NOTFOUND = 2;
   */
  SE_TRACK_NOTFOUND = 2,
}

/**
 * Describes the enum livekit.SubscriptionError.
 */
export const SubscriptionErrorSchema: GenEnum<SubscriptionError> = /*@__PURE__*/
  enumDesc(file_livekit_models, 12);

/**
 * @generated from enum livekit.AudioTrackFeature
 */
export enum AudioTrackFeature {
  /**
   * @generated from enum value: TF_STEREO = 0;
   */
  TF_STEREO = 0,

  /**
   * @generated from enum value: TF_NO_DTX = 1;
   */
  TF_NO_DTX = 1,

  /**
   * @generated from enum value: TF_AUTO_GAIN_CONTROL = 2;
   */
  TF_AUTO_GAIN_CONTROL = 2,

  /**
   * @generated from enum value: TF_ECHO_CANCELLATION = 3;
   */
  TF_ECHO_CANCELLATION = 3,

  /**
   * @generated from enum value: TF_NOISE_SUPPRESSION = 4;
   */
  TF_NOISE_SUPPRESSION = 4,

  /**
   * @generated from enum value: TF_ENHANCED_NOISE_CANCELLATION = 5;
   */
  TF_ENHANCED_NOISE_CANCELLATION = 5,

  /**
   * client will buffer audio once available and send it to the server via bytes stream once connected
   *
   * @generated from enum value: TF_PRECONNECT_BUFFER = 6;
   */
  TF_PRECONNECT_BUFFER = 6,
}

/**
 * Describes the enum livekit.AudioTrackFeature.
 */
export const AudioTrackFeatureSchema: GenEnum<AudioTrackFeature> = /*@__PURE__*/
  enumDesc(file_livekit_models, 13);

/**
 * @generated from enum livekit.PacketTrailerFeature
 */
export enum PacketTrailerFeature {
  /**
   * @generated from enum value: PTF_USER_TIMESTAMP = 0;
   */
  PTF_USER_TIMESTAMP = 0,

  /**
   * @generated from enum value: PTF_FRAME_ID = 1;
   */
  PTF_FRAME_ID = 1,

  /**
   * @generated from enum value: PTF_USER_DATA = 2;
   */
  PTF_USER_DATA = 2,
}

/**
 * Describes the enum livekit.PacketTrailerFeature.
 */
export const PacketTrailerFeatureSchema: GenEnum<PacketTrailerFeature> = /*@__PURE__*/
  enumDesc(file_livekit_models, 14);

